import React, { useEffect, useRef } from 'react'
import L from 'leaflet'
import { Circle, useMap, Tooltip } from 'react-leaflet'
import icon from 'leaflet/dist/images/marker-icon.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'

const DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow
})
L.Marker.prototype.options.icon = DefaultIcon

const MapMarker = props => {
  const { selectedLocation } = props
  const map = useMap()
  const groupRef = useRef()

  useEffect(() => {
    groupRef.current && map.removeLayer(groupRef.current)
    const circleArray = selectedLocation.filter(i => i.latitude).map(i => L.circle([i.latitude, i.longitude], i.radius))
    if (!circleArray.length) return
    const group = L.featureGroup(circleArray).addTo(map)
    groupRef.current = group
    map.fitBounds(group.getBounds())
  }, [map, selectedLocation])

  return (
    selectedLocation?.map((location, index) => {
      const { longitude: lng, latitude: lat, radius, name } = location
      return (
        lng && lat && radius
          ? <Circle center={{ lat, lng }} radius={radius} key={`circle_${index}`}>
              <Tooltip permanent direction='top'>{name}</Tooltip>
            </Circle>
          : ''
      )
    })
  )
}

export default MapMarker
